import { states } from '@/features/shared/constants/states'
import { isValidZip } from '@/features/shared/utils/validator'
import { type ValidAddress } from '@/features/account/services/Addresses/types'
import { z } from 'zod'

export const zipValidation = z.string().refine(isValidZip, {
  message: 'Zip is invalid',
})

const isValidStateAbbreviation = (state = '') => {
  return state.toUpperCase() in states
}

const stateValidation = z.string().refine(isValidStateAbbreviation, {
  message: 'State is invalid',
})

export const addressValidationSchema = z.object({
  street1: z.string().min(1, 'Street must be present'),
  street2: z.string().optional(),
  city: z.string().min(1, 'City must be present'),
  state: stateValidation,
  zip_code: zipValidation,
  delivery_instructions: z.string().optional(),
  door_dropoff: z.boolean().optional(),
  property_type: z.string().optional(),
  requested_delivery_location: z.string().optional(),
  shopper_arrive: z.array(z.string()).optional(),
  gate_code: z.string().optional(),
})

export const isValidAddress = (address?: ValidAddress | null): address is ValidAddress => {
  const { street1, city, state, zip_code } = address ?? {}
  return (
    Boolean(street1?.length) &&
    Boolean(city?.length) &&
    isValidStateAbbreviation(state) &&
    isValidZip(zip_code ?? '')
  )
}
